<template>
    <b-tabs
        :showBackground="showBackground"
        :value="value"
        :vertical="vertical"
        @activate-tab="handleActivateTab"
        @changed="handleChanged"
        @input="$emit('input', $event)"
    >
        <template v-if="$slots['tabs-start']" #tabs-start>
            <slot name="tabs-start" />
        </template>

        <template v-if="$slots['tabs-end']" #tabs-end>
            <slot name="tabs-end" />
        </template>

        <template v-if="$slots['empty']" #empty>
            <slot name="empty" />
        </template>

        <slot />
    </b-tabs>
</template>

<script>
import { BTabs } from 'bootstrap-vue'

export default {
    components: { BTabs },
    data: () => ({
        validTabIndex: null,
    }),
    methods: {
        handleActivateTab(newTabIndex, prevTabIndex, bvEvent) {
            if (!Array.isArray(this.tabRefs)) {
                this.$emit('activate-tab', newTabIndex, prevTabIndex, bvEvent)
                return
            }

            if (newTabIndex === this.validTabIndex) {
                this.validTabIndex = null
                return
            }

            bvEvent.preventDefault()

            this.tabRefs[prevTabIndex].validate()
                .then(valid => {
                    if (valid) {
                        this.validTabIndex = newTabIndex
                        this.$emit('input', newTabIndex)
                    } else {
                        this.$emit('input', prevTabIndex)
                    }
                })
        },
        handleChanged(currentTabs, previousTabs) {
            this.$emit('changed', currentTabs, previousTabs)
        },
    },
    props: {
        showBackground: { type: Boolean },
        tabRefs: { type: Array },
        value: { type: Number, default: null },
        vertical: { type: Boolean },
    },
}
</script>

<style scoped>
.tabs:not([showBackground]) >>> .nav-tabs {
    background: rgb(255 255 255);
}
[showBackground] >>> .nav-tabs {
    background: rgb(245 245 245);
}
</style>